<template>
  <lw-overlay
    :size="'c1'"
    :colour="'cream'"
  >
    <div class="grid grid-columns-6_md align-content-center vh75 mb-margin">
      <div class="grid-column-start-2_md grid-column-end-6_md">
        <h1 class="mb2">Manage <span class="accent-text">{{ estimate.project }}</span> red&nbsp;flags</h1>
        <p class="measure mb2">Check the red flags that apply to your <em>{{ estimate.project }}</em> estimate. Red flags are good risk indicators and will help refine your estimate range.</p>
        <form
          class="c1 block overflow-hidden"
          @submit.prevent="estimateSettings">
          <button
            v-if="redFlags.length > 10"
            type="submit"
            name="submit2"
            class="large-button accent-button mr1 right">Done</button>
          <lw-table
            v-if="redFlags"
            :type="'lined'"
            :class="'flag-table c1 clear'">
            <tr
              v-for="(flag, index) in redFlags"
              :key="index">
              <td>
                <lw-checkbox
                  :name="'redFlags'"
                  :class="'mb0'"
                  :id="'redFlag-' + index"
                  :val="flag.id"
                  v-model="flags"
                >{{ flag.title }}</lw-checkbox>
              </td>
            </tr>
          </lw-table>
          <div class="flex justify-content-space-between align-items-center">
            <button
              class="large-button invisible-button"
              @click.prevent="$router.push({ name: 'newRedFlag' })">+ Add a red flag</button>
            <button
              type="submit"
              name="submit"
              class="large-button accent-button">Done</button>
          </div>
        </form>
      </div>
    </div>
  </lw-overlay>
</template>

<script>
import { mapGetters } from 'vuex'
import VueMarkdown from 'vue-markdown'
import Table from '../livewires/Table'
import Checkbox from '../livewires/Checkbox'
import Overlay from '../livewires/Overlay'

export default {
  components: {
    lwTable: Table,
    lwCheckbox: Checkbox,
    lwOverlay: Overlay,
    vueMarkdown: VueMarkdown
  },
  data () {
    return {
      page: this.$route.params.id,
      flags: []
    }
  },
  computed: {
    ...mapGetters([
      'redFlags'
    ]),
    estimate () {
      return this.$store.getters.estimate(this.page)
    }
  },
  watch: {
    estimate (value) {
      if (value.redFlags) {
        this.flags = Object.keys(value.redFlags)
      }
    }
  },
  mounted () {
    if (this.estimate.redFlags) {
      this.flags = Object.keys(this.estimate.redFlags)
    }
  },
  methods: {
    estimateSettings () {
      this.$store.dispatch('saveState', false)
      let payload = { ...this.estimate }
      payload.id = this.page
      const rf = this.flags
      const redFlags = Object.assign({}, ...rf.map(item => ({ [item]: true })))
      payload.redFlags = redFlags
      this.$store.dispatch('estimateSettings', payload).then(response => {
        this.$router.go(-1)
        this.$emit('redrawChart')
      })
    }
  }
}
</script>

<style scoped>
.flag-table {

}
</style>
